import React,{useState,useEffect} from 'react'
import {motion} from 'framer-motion'
import Cookies from 'js-cookie'
import { useTranslation} from "react-i18next";

import './About.scss'
import { urlFor,client } from '../../client'
import {AppWrap,MotionWrap} from '../../wrappers'

const About = () => {
  const { t } = useTranslation();
  const [abouts, setAbouts] = useState([])

  useEffect(() => {
  const currentLocale = Cookies.get('i18next') ?? 'en'
  
   const query=`*[_type=="abouts" && locale == "${currentLocale}"] | order(index asc)`

   client.fetch(query)
   .then((data)=> setAbouts(data))
  }, [Cookies.get('i18next')])
  
  return (
    <>
    <h2 className='head-text'>
    {t('about-1')} <span>{t('about-2')}</span><br/> {t('about-3')} <span>{t('about-4')}</span>
    </h2>

    <div className='app__profiles'>
    {abouts.map((about,index)=> (
      <motion.div
      whileInView={{opacity:1}}
      whileHover={{scale:1.1}}
      transition={{duration:0.5,type:'tween'}}
      className='app__profile-item'
      key={about.title+index}
      >
        <img src={urlFor(about.imgUrl)} alt={about.title}/>
        <h2 className='bold-text' style={{marginTop:20}}>{about.title}</h2>
        <p className='p-text' style={{marginTop:10}}>{about.description}</p>
      </motion.div>
    ))}
    </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About,'app__about'),
  'about',
  "app__whitebg"
  )